<template>
    <div class="container">
        <BackButton
            defaultRoute="/members/studio-finder"
            containerClass="studio__btn"
        />
        <div class="studio__title">{{currentItem.title}}</div>

        <div class="d-flex justify-space-between studio__inner">
            <div class="d-flex flex studio__info-row lg3 md12 sm12 xs12">
                <div class="studio__info flex lg12 md4 sm4 xs12">
                    <div class="studio__info-title">{{currentItem.title}}</div>
                    <div class="studio__info-item">{{currentItem.address}}</div>
                    <div>
                        <span class="studio__info-item">{{currentItem.postal_code}}</span>
                        <span class="studio__info-item"> {{currentItem.city}}</span>
                    </div>
                    <div>
                        <span class="studio__info-item">{{$t('form.telephone')}}:</span>
                        <a class="studio__info-item-orange" :href="`tel:${currentItem.phone_number}`"> {{currentItem.phone_number}}</a>
                    </div>
                    <div>
                        <span class="studio__info-item">{{$t('form.email')}}:</span>
                        <a class="studio__info-item-orange" :href="`mailto:${currentItem.email}`"> {{currentItem.email}}</a>
                    </div>
                    <div>
                        <span class="studio__info-item">{{$t('form.web')}}:</span>
                        <a class="studio__info-item-orange" :href="currentItem.url" target="_blank"> {{currentItem.url}}</a>
                    </div>
                </div>
<!--                <div class="studio__info flex lg12 md4 sm4 xs12">-->
<!--                    <div class="studio__info-title">{{$t('members.members-studio-page.opening_hours')}}</div>-->
<!--                    <div-->
<!--                        v-for="(item, i) in openingHours"-->
<!--                        :key="i"-->
<!--                        class="d-flex lg3 justify-space-between"-->
<!--                    >-->
<!--                        <span class="studio__info-day">{{item.day}}: </span>-->
<!--                        <span class="studio__info-item">{{item.open}} - {{item.close}}</span>-->
<!--                    </div>-->
<!--                </div>-->
            </div>

            <div class="studio__map flex lg8 md12 sm12 xs12" >
                <div
                        class="map__container"
                        :class="mapLoaded ? 'is-ready': 'is-not-ready'"
                        id="map">

                    <div class="map__container-modal" v-if="!mapLoaded">
                        <div class="map__container-modal-header">
                            <span class="map__container-modal-header__line"/>
                            <div class="map__container-modal-header__icon">
                                <svg-icon name="mapModal"/>
                            </div>
                        </div>

                        <div class="map__container-modal-main">
                            {{$t('members.members-studio-page.map_text')}}
                        </div>

                        <div class="map__container-modal-footer" @click="createMap">
                            {{$t('members.members-studio-page.map_activate')}}
                        </div>
                    </div>
                </div>


            </div>
        </div>


    </div>
</template>

<script>
    import { getStudio } from "@/api/clientServices";

    import mapboxgl from 'mapbox-gl'


    export default {

        props: {
            item: {
                type: Object,
                required: false,
            }
        },

        data() {
            return {
                map: null,
                currentItem: {
                    latitude: 0,
                    longitude: 0
                },
                mapIsReady: false,
                mapStyle: "mapbox://styles/mapbox/outdoors-v9",
                zoomLevel: 12,
                mapLoaded: false
            }
        },

        methods: {
            createMap() {
                let {longitude, latitude} = this.currentItem;
                mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN;
                this.mapLoaded = false;
                this.map = new mapboxgl.Map({
                    container: 'map',
                    style: 'mapbox://styles/mapbox/outdoors-v9',
                    attributionControl: false,
                    zoom: this.zoomLevel,
                    center: [longitude, latitude],
                });

                this.map.on("load", () => {
                    let vm = this;
                    vm.mapLoaded = true;

                    new mapboxgl.Marker({ icon: 'default', color: 'red' })
                        .setLngLat([longitude, latitude])
                        .addTo(vm.map);
                })
            },
            convertTime(time) {
                return new Date('1970-01-01T' + time)
                    .toLocaleTimeString({},
                        {hour12:true,hour:'numeric',minute:'numeric'}
                    );
            }
        },


        computed: {
            openingHours() {
                let days = this.$t('form.days');
                let res = [];

                this.currentItem.opening_hours && this.currentItem.opening_hours.forEach((item, i) => {
                    res.push({
                        day: days[i],
                        open: item[0] ? this.convertTime(item[0]) : '',
                        close: item[1] ? this.convertTime(item[1]) : '',
                    })
                });

                return res;
            },
        },
        async mounted() {
            if (this.item) {
                this.currentItem = {...this.item};
            } else {
                await getStudio(this.$route.params.slug)
                    .then(res => {
                        this.currentItem = {...res.data.data.studio};
                    })
                .catch(e => console.log(e, 'e here'))
            }
            // this.createMap()
        },
        beforeDestroy() {
            this.map = null
            this.mapLoaded = false
        }

    }
</script>

<style lang="sass" scoped>
    .studio
        &__btn
            flex: initial

        &__inner
            +r(1263)
                flex-wrap: wrap

        &__title
            margin-top: 16px
            +reg
            font-weight: 600
            font-size: 40px
            letter-spacing: 1px
            color: $color--dark
            padding-bottom: 16px
            margin-bottom: 24px
            border-bottom: 1px solid rgba($color--dark, 0.1)

        &__info
            flex-direction: column

            &-title
                +reg
                font-weight: 600
                font-size: 18px
                color: #01254E
                padding-bottom: 8px

            &-item
                +reg
                font-size: 14px
                color: ($color--dark-lighten, 0.6)
                padding-bottom: 4px


                &-orange
                    +reg
                    font-size: 14px
                    color: $color--flame
                    text-decoration: none
                    word-break: break-all


            &-row
                flex-direction: column

            &-day
                +semi
                font-weight: 500
                color: #01254E

            &:first-child
                padding-bottom: 48px
                border-bottom: 1px solid rgba($color--dark, 0.1)

            &:last-child
                padding-top: 48px

            +r(1263)
                flex-direction: row

                &:first-child, &:last-child
                    padding: 0

                &:first-child
                    margin-right: 121px
                    border-bottom: none

                &-row
                    padding-bottom: 40px
                    margin-bottom: 40px
                    border-bottom: 1px solid rgba($color--dark, 0.1)

                    +r(599)
                        flex-direction: column
                        padding-bottom: 0
                        border-bottom: none

            +r(599)
                &:first-child
                    margin-right: 0
                    padding-bottom: 16px
                    margin-bottom: 16px
                    border-bottom: 1px solid rgba($color--dark, 0.1)


        &__map
            overflow: hidden
            position: relative
            height: 460px
    .map
        &__container
            display: flex
            align-items: center
            justify-content: center
            position: absolute
            top: 0
            left: 0
            width: 100%
            height: 100%
            opacity: 1
            visibility: visible
            border: 0
            outline: 0
            transition: opacity .3s ease, visibility .3s ease
            &.is-ready
                opacity: 1
                visibility: visible

            &.is-not-ready
                background: #9EA5B3

            &-modal
                background: $color--white
                box-shadow: 0 8px 16px rgba(11, 35, 75, 0.15)
                width: 667px
                padding: 32px 40px

                &-header
                    position: relative
                    &__line
                        display: block
                        height: 1px
                        width: 100%
                        background: $color--dark
                        position: absolute
                        top: 50%
                        transform: translateY(-50%)

                    &__icon
                        width: 90px
                        background: $color--white
                        position: absolute
                        top: -50%
                        left: 50%
                        transform: translateX(-50%)
                        height: 30px
                        margin-top: -15px
                        display: flex
                        justify-content: center

                &-main
                    margin-top: 27px
                    +reg
                    font-size: 16px
                    color: $color--dark
                    text-align: justify

                &-footer
                    margin-top: 16px
                    +reg
                    font-size: 16px
                    color: $color--flame
                    text-decoration: underline
                    cursor: pointer
                    letter-spacing: 0.05em

    .icon-mapModal
        height: 30px
        width: 40px
</style>